import Campaigns from '@/views/Campaigns/Index'
import CampaignsCampaigns from '@/views/Campaigns/Campaigns/Index'
import CampaignsCampaignsCampaign from '@/views/Campaigns/Campaigns/Campaign'

export default [
    {
        path: '/campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {
            title: 'Kampanie',
            menuRendered: true,
            menuTitle: 'Kampanie',
            requiresAuth: true,
            permission: 'jmd_campaign',
            icon: 'mdi-bullhorn-outline',
        },
        children: [
            {
                path: '/campaigns/campaigns',
                name: 'campaignsCampaigns',
                component: CampaignsCampaigns,
                meta: {
                    title: 'Kampanie / Lista kampanii',
                    menuRendered: true,
                    menuTitle: 'JMD',
                    requiresAuth: true,
                    permission: 'jmd_campaign_read',
                },
            },
            {
                path: '/campaigns/campaigns/:id',
                name: 'campaignsCampaignsDetail',
                component: CampaignsCampaignsCampaign,
                meta: {
                    title: 'Kampanie / Edycja kampanii',
                    requiresAuth: true,
                    permission: 'jmd_campaign_read',
                },
            },
        ],
    }
]
